const REPORT_TYPE = {
  BOOK: 'book',
  FLOW: 'flow',
  BALANCE: 'balance',
  LEDGER: 'ledger',
  JOURNAL: 'journal',
  DEBT_SUMMARY: 'debt_summary',
  DEBT_DETAIL: 'debt_detail',
  DEBT_AGING: 'debt_aging',
  DEBT_AGING_DETAIL: 'debt_aging_detail',
  TURNOVER_SUMMARY: 'turnover_summary',
  TURNOVER_DETAIL: 'turnover_detail',
  PURCHASE_ORDER_PROGRESS: 'purchase_order_progress',
  PURCHASE_RECEIVING_SUMMARY: 'purchase_receiving_summary',
  PURCHASE_CONTRACT_PROGRESS: 'purchase_contract_progress',
  INVENTORY_SUMMARY: 'inventory_summary',
  INVENTORY_DETAIL: 'inventory_detail',
  INVENTORY_TRANSFER: 'inventory_transfer',
  INVENTORY_RECONCILIATION: 'inventory_reconciliation',
  INVENTORY_PENDING_TRANSFER: 'inventory_pending_transfer',
  VAT_SUMMARY: 'vat_summary',
  VAT_DETAIL: 'vat_detail',
  FINANCIAL_STATEMENT: 'financial_statement',
  TRIAL_BALANCE: 'trial_balance',
};

export const ACCOUNTING_REPORT_PERMISSION = 'RP_ACCOUNTING_REPORT_VIEW';

export const ACCOUNTING_REPORTS = [
  {
    code: 'CASH-001',
    path: '/accounting-reports/cash-001',
    name: 'Sổ quỹ tiền mặt',
    group: 'Quỹ',
    type: REPORT_TYPE.BOOK,
    menuIcon: 'fi fi-rr-wallet',
  },
  {
    code: 'CASH-002',
    path: '/accounting-reports/cash-002',
    name: 'Dòng tiền tiền mặt',
    group: 'Quỹ',
    type: REPORT_TYPE.FLOW,
    menuIcon: 'fi fi-rr-chart-histogram',
  },
  {
    code: 'CASH-003',
    path: '/accounting-reports/cash-003',
    name: 'Bảng kê số dư quỹ theo ngày',
    group: 'Quỹ',
    type: REPORT_TYPE.BALANCE,
    menuIcon: 'fi fi-rr-calendar-lines',
  },
  {
    code: 'BANK-001',
    path: '/accounting-reports/bank-001',
    name: 'Sổ ngân hàng',
    group: 'Ngân hàng',
    type: REPORT_TYPE.BOOK,
    menuIcon: 'fi fi-rr-bank',
  },
  {
    code: 'BANK-003',
    path: '/accounting-reports/bank-003',
    name: 'Dòng tiền ngân hàng',
    group: 'Ngân hàng',
    type: REPORT_TYPE.FLOW,
    menuIcon: 'fi fi-rr-chart-histogram',
  },
  {
    code: 'BANK-005',
    path: '/accounting-reports/bank-005',
    name: 'Bảng kê số dư ngân hàng theo tài khoản',
    group: 'Ngân hàng',
    type: REPORT_TYPE.BALANCE,
    menuIcon: 'fi fi-rr-credit-card',
  },
  {
    code: 'BANK-006',
    path: '/accounting-reports/bank-006',
    name: 'Bảng kê số dư ngân hàng theo ngày',
    group: 'Ngân hàng',
    type: REPORT_TYPE.BALANCE,
    menuIcon: 'fi fi-rr-calendar-lines',
  },
  {
    code: 'GL-001',
    path: '/accounting-reports/gl-001',
    aliases: ['/accounting/account-ledger'],
    name: 'Sổ chi tiết tài khoản',
    group: 'Sổ kế toán',
    type: REPORT_TYPE.LEDGER,
    menuIcon: 'fi fi-rr-book-alt',
  },
  {
    code: 'GL-002',
    path: '/accounting-reports/gl-002',
    name: 'Sổ cái',
    group: 'Sổ kế toán',
    type: REPORT_TYPE.LEDGER,
    menuIcon: 'fi fi-rr-book',
  },
  {
    code: 'GL-003',
    path: '/accounting-reports/gl-003',
    name: 'Sổ nhật ký thu tiền',
    group: 'Nhật ký',
    type: REPORT_TYPE.JOURNAL,
    menuIcon: 'fi fi-rr-receipt',
  },
  {
    code: 'GL-004',
    path: '/accounting-reports/gl-004',
    name: 'Sổ nhật ký chi tiền',
    group: 'Nhật ký',
    type: REPORT_TYPE.JOURNAL,
    menuIcon: 'fi fi-rr-money-bill-wave-alt',
  },
  {
    code: 'GL-005',
    path: '/accounting-reports/gl-005',
    aliases: ['/accounting/trial-balance'],
    name: 'Bảng cân đối số phát sinh',
    group: 'Sổ kế toán',
    type: REPORT_TYPE.TRIAL_BALANCE,
    menuIcon: 'fi fi-rr-balance-scale-left',
  },
  {
    code: 'FIN-001',
    path: '/accounting-reports/fin-001',
    name: 'Bảng cân đối tài khoản',
    group: 'Báo cáo tài chính',
    type: REPORT_TYPE.TRIAL_BALANCE,
    menuIcon: 'fi fi-rr-chart-pie-alt',
  },
  {
    code: 'AR-001',
    path: '/accounting-reports/ar-001',
    name: 'Tổng hợp công nợ phải thu khách hàng',
    group: 'Công nợ phải thu',
    type: REPORT_TYPE.DEBT_SUMMARY,
    menuIcon: 'fi fi-rr-user-time',
  },
  {
    code: 'AR-002',
    path: '/accounting-reports/ar-002',
    name: 'Chi tiết công nợ phải thu khách hàng',
    group: 'Công nợ phải thu',
    type: REPORT_TYPE.DEBT_DETAIL,
    menuIcon: 'fi fi-rr-user',
  },
  {
    code: 'AR-005',
    path: '/accounting-reports/ar-005',
    name: 'Báo cáo nợ phải thu quá hạn',
    group: 'Công nợ phải thu',
    type: REPORT_TYPE.DEBT_AGING,
    menuIcon: 'fi fi-rr-alarm-clock',
  },
  {
    code: 'AR-007',
    path: '/accounting-reports/ar-007',
    name: 'Tổng hợp tuổi nợ phải thu',
    group: 'Công nợ phải thu',
    type: REPORT_TYPE.DEBT_AGING,
    menuIcon: 'fi fi-rr-calendar-clock',
  },
  {
    code: 'AR-008',
    path: '/accounting-reports/ar-008',
    name: 'Chi tiết tuổi nợ phải thu',
    group: 'Công nợ phải thu',
    type: REPORT_TYPE.DEBT_AGING_DETAIL,
    menuIcon: 'fi fi-rr-calendar-lines',
  },
  {
    code: 'AP-001',
    path: '/accounting-reports/ap-001',
    name: 'Tổng hợp công nợ phải trả nhà cung cấp',
    group: 'Công nợ phải trả',
    type: REPORT_TYPE.DEBT_SUMMARY,
    menuIcon: 'fi fi-rr-truck-loading',
  },
  {
    code: 'AP-002',
    path: '/accounting-reports/ap-002',
    name: 'Chi tiết công nợ phải trả nhà cung cấp',
    group: 'Công nợ phải trả',
    type: REPORT_TYPE.DEBT_DETAIL,
    menuIcon: 'fi fi-rr-file-invoice-dollar',
  },
  {
    code: 'AP-005',
    path: '/accounting-reports/ap-005',
    name: 'Báo cáo nợ phải trả quá hạn',
    group: 'Công nợ phải trả',
    type: REPORT_TYPE.DEBT_AGING,
    menuIcon: 'fi fi-rr-alarm-clock',
  },
  {
    code: 'AP-007',
    path: '/accounting-reports/ap-007',
    name: 'Chi tiết tuổi nợ phải trả',
    group: 'Công nợ phải trả',
    type: REPORT_TYPE.DEBT_AGING_DETAIL,
    menuIcon: 'fi fi-rr-calendar-lines',
  },
  {
    code: 'SALE-001',
    path: '/accounting-reports/sale-001',
    name: 'Tổng hợp bán hàng',
    group: 'Bán hàng',
    type: REPORT_TYPE.TURNOVER_SUMMARY,
    menuIcon: 'fi fi-rr-shopping-cart',
  },
  {
    code: 'SALE-002',
    path: '/accounting-reports/sale-002',
    name: 'S35-DN: Sổ chi tiết bán hàng',
    group: 'Bán hàng',
    type: REPORT_TYPE.TURNOVER_DETAIL,
    menuIcon: 'fi fi-rr-receipt',
  },
  {
    code: 'SALE-006',
    path: '/accounting-reports/sale-006',
    name: 'Sổ chi tiết bán hàng theo hạch toán',
    group: 'Bán hàng',
    type: REPORT_TYPE.TURNOVER_DETAIL,
    menuIcon: 'fi fi-rr-book-alt',
    viewPermission: 'AC_SALES_POSTING_LEDGER_VIEW',
  },
  {
    code: 'SALE-005',
    path: '/accounting-reports/sale-005',
    name: 'Nhật ký bán hàng',
    group: 'Bán hàng',
    type: REPORT_TYPE.TURNOVER_DETAIL,
    menuIcon: 'fi fi-rr-book-open-cover',
  },
  {
    code: 'PUR-001',
    path: '/accounting-reports/pur-001',
    aliases: ['/purchase-report'],
    name: 'Tổng hợp mua hàng',
    group: 'Mua hàng',
    type: REPORT_TYPE.TURNOVER_SUMMARY,
    menuIcon: 'fi fi-rr-cart-arrow-down',
  },
  {
    code: 'PUR-002',
    path: '/accounting-reports/pur-002',
    name: 'Chi tiết mua hàng',
    group: 'Mua hàng',
    type: REPORT_TYPE.TURNOVER_DETAIL,
    menuIcon: 'fi fi-rr-file-invoice',
  },
  {
    code: 'PUR-004',
    path: '/accounting-reports/pur-004',
    name: 'Nhật ký mua hàng',
    group: 'Mua hàng',
    type: REPORT_TYPE.TURNOVER_DETAIL,
    menuIcon: 'fi fi-rr-book-open-cover',
  },
  {
    code: 'PUR-005',
    path: '/accounting-reports/pur-005',
    name: 'Tình hình thực hiện đơn mua hàng',
    group: 'Mua hàng',
    type: REPORT_TYPE.PURCHASE_ORDER_PROGRESS,
    menuIcon: 'fi fi-rr-clipboard-list-check',
  },
  {
    code: 'PUR-006',
    path: '/accounting-reports/pur-006',
    name: 'Thống kê số lượng nhận hàng theo đơn',
    group: 'Mua hàng',
    type: REPORT_TYPE.PURCHASE_RECEIVING_SUMMARY,
    menuIcon: 'fi fi-rr-truck-arrow-right',
  },
  {
    code: 'PUR-007',
    path: '/accounting-reports/pur-007',
    name: 'Tình hình thực hiện hợp đồng mua',
    group: 'Mua hàng',
    type: REPORT_TYPE.PURCHASE_CONTRACT_PROGRESS,
    menuIcon: 'fi fi-rr-file-contract',
  },
  {
    code: 'INV-001',
    path: '/accounting-reports/inv-001',
    name: 'Tổng hợp tồn kho',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_SUMMARY,
    menuIcon: 'fi fi-rr-boxes',
  },
  {
    code: 'INV-004',
    path: '/accounting-reports/inv-004',
    name: 'Chi tiết nhập xuất tồn',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_DETAIL,
    menuIcon: 'fi fi-rr-warehouse-alt',
  },
  {
    code: 'INV-005',
    path: '/accounting-reports/inv-005',
    name: 'Bảng cân đối tài khoản kho',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_SUMMARY,
    menuIcon: 'fi fi-rr-balance-scale-left',
  },
  {
    code: 'INV-007',
    path: '/accounting-reports/inv-007',
    name: 'Sổ chuyển kho nội bộ',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_TRANSFER,
    menuIcon: 'fi fi-rr-truck-moving',
  },
  {
    code: 'INV-008',
    path: '/accounting-reports/inv-008',
    name: 'Đối chiếu xuất nhập giữa chi nhánh',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_RECONCILIATION,
    menuIcon: 'fi fi-rr-arrows-repeat',
  },
  {
    code: 'INV-009',
    path: '/accounting-reports/inv-009',
    name: 'Thẻ kho theo tài khoản',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_DETAIL,
    menuIcon: 'fi fi-rr-list-check',
  },
  {
    code: 'INV-010',
    path: '/accounting-reports/inv-010',
    name: 'Tồn kho theo chứng từ nhập chưa chuyển kho',
    group: 'Kho',
    type: REPORT_TYPE.INVENTORY_PENDING_TRANSFER,
    menuIcon: 'fi fi-rr-inbox-in',
  },
  {
    code: 'TAX-003',
    path: '/accounting-reports/tax-003',
    name: 'Bảng kê VAT đầu vào',
    group: 'Thuế',
    type: REPORT_TYPE.VAT_DETAIL,
    menuIcon: 'fi fi-rr-percent',
  },
  {
    code: 'TAX-004',
    path: '/accounting-reports/tax-004',
    name: 'Bảng kê VAT đầu ra',
    group: 'Thuế',
    type: REPORT_TYPE.VAT_DETAIL,
    menuIcon: 'fi fi-rr-percent',
  },
  {
    code: 'TAX-005',
    path: '/accounting-reports/tax-005',
    name: 'Tổng hợp VAT',
    group: 'Thuế',
    type: REPORT_TYPE.VAT_SUMMARY,
    menuIcon: 'fi fi-rr-chart-pie-simple',
  },
  {
    code: 'FIN-003',
    path: '/accounting-reports/fin-003',
    name: 'Bảng cân đối kế toán',
    group: 'Báo cáo tài chính',
    type: REPORT_TYPE.FINANCIAL_STATEMENT,
    menuIcon: 'fi fi-rr-document-signed',
  },
  {
    code: 'FIN-004',
    path: '/accounting-reports/fin-004',
    name: 'Báo cáo kết quả kinh doanh',
    group: 'Báo cáo tài chính',
    type: REPORT_TYPE.FINANCIAL_STATEMENT,
    menuIcon: 'fi fi-rr-chart-line-up',
  },
  {
    code: 'FIN-005',
    path: '/accounting-reports/fin-005',
    name: 'Báo cáo lưu chuyển tiền tệ',
    group: 'Báo cáo tài chính',
    type: REPORT_TYPE.FINANCIAL_STATEMENT,
    menuIcon: 'fi fi-rr-chart-histogram',
  },
  {
    code: 'FIN-008',
    path: '/accounting-reports/fin-008',
    name: 'Thuyết minh báo cáo tài chính',
    group: 'Báo cáo tài chính',
    type: REPORT_TYPE.FINANCIAL_STATEMENT,
    menuIcon: 'fi fi-rr-memo-circle-info',
  },
];

export const getAccountingReportByCode = (code = '') => {
  const normalizedCode = String(code || '').toUpperCase();
  return ACCOUNTING_REPORTS.find((item) => item.code === normalizedCode) || ACCOUNTING_REPORTS[0];
};

export const getAccountingReportByPath = (pathname = '') => {
  const normalizedPath = String(pathname || '').replace(/^\/portal(?=\/)/, '');
  return (
    ACCOUNTING_REPORTS.find((item) => item.path === normalizedPath || item.aliases?.includes(normalizedPath)) ||
    ACCOUNTING_REPORTS[0]
  );
};

export { REPORT_TYPE };
